import { render, staticRenderFns } from "./RELSubsidio.vue?vue&type=template&id=c78a2cbc&"
import script from "./RELSubsidio.vue?vue&type=script&lang=js&"
export * from "./RELSubsidio.vue?vue&type=script&lang=js&"
import style0 from "./RELSubsidio.vue?vue&type=style&index=0&id=c78a2cbc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports